<template>
	<div>
		<div v-if="$route.path == '/AgentOrder/AgentOrder'">
			<el-form :inline="true" class="toolbar">
				<el-form-item label="销售下单号:" label-width="100px">
					<el-input v-model="query.OrderCode"></el-input>
				</el-form-item>
				<el-form-item label="出库单号:" label-width="90px">
					<el-input v-model="query.OutCode"></el-input>
				</el-form-item>
				<el-form-item label="物流单号:" label-width="80px">
					<el-input v-model="query.LogCode"></el-input>
				</el-form-item>
				<el-form-item label="出库单状态:" label-width="100px">
					<el-select placeholder="-请选择-" class="formlength" v-model="query.Status">
						<el-option v-for="option in queryType" :value="option.TypeValue" :label="option.TypeName">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="收货状态:" label-width="90px">
					<el-select placeholder="-请选择-" class="formlength" v-model="query.ReceivingStatus">
						<el-option v-for="option in queryDelivery" :value="option.TypeValue" :label="option.TypeName">
						</el-option>
					</el-select>
				</el-form-item>
				<el-button type="primary" @click="onQuerySubmit" icon="search">查询</el-button>
				<el-button type="primary" @click="onQueryClean" icon="delete2">重置</el-button>
			</el-form>
			<div>
				<el-table :data="lists" v-loading="loading2" element-loading-text="拼命加载中" border style="width: 100%;" @selection-change="selsChange" router>
					<el-table-column label="出库单号" prop="StockOutCode"></el-table-column>
					<el-table-column label="销售下单时间" prop="OrderTime"></el-table-column>
					<el-table-column label="业务员" prop="SaleEmployeeName"></el-table-column>
					<el-table-column label="实际发货时间" prop="StockOutTime"></el-table-column>
					<el-table-column label="实际签收时间" prop="SignTime"></el-table-column>
					<el-table-column label="物流单号" prop="LogisticsCode"></el-table-column>
					<el-table-column label="出库单状态" prop="StatusName"></el-table-column>
					<el-table-column label="收货状态" prop="ReceivingStatusName"></el-table-column>
					<el-table-column label="操作" width="200px">
						<template scope="scope">
							<el-button size="small" @click="handleView(scope.$index, scope.row)" icon="view" type="success">查看</el-button>
							<el-button size="small" @click="harvest(scope.row)" icon="menu" :disabled="(scope.row.btnVue&1024)<=0" type="primary">收货</el-button>
							<!--<el-button size="small" @click="feedback(scope.row)" icon="message" :disabled="(scope.row.btnVue&2048)<=0"  type="info">反馈</el-button>-->
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-col :span="24" class='btm-action'>
	
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize*1" style="float: right">
				</el-pagination>
			</el-col>
			<el-dialog title="收货" v-model="SaleCheckView" size="tiny">
				<el-row>
					<div>
						<div>商品</div>
						<el-table :data="GoodsList.ListGoods" border style="width: 100%">
							<el-table-column prop="ProName" label="名称">
							</el-table-column>
							<el-table-column prop="SendNum" label="总数">
							</el-table-column>
							<el-table-column prop="ActualNum" label="实发">
							</el-table-column>
							<el-table-column label="实收" width="160">
								<template scope="scope">
									<el-input-number size="small" v-model="scope.row.ProNum" :min="0" :max="scope.row.ActualNum" style="display: flex;align-items: center"></el-input-number>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div v-show="GoodsList.GiftGoods!=''">
						<div>赠品</div>
						<el-table :data="GoodsList.GiftGoods" border style="width: 100%">
							<el-table-column prop="ProName" label="名称">
							</el-table-column>
							<el-table-column prop="SendNum" label="总数">
							</el-table-column>
							<el-table-column prop="ActualNum" label="实发">
							</el-table-column>
							<el-table-column label="实收" width="160">
								<template scope="scope">
									<el-input-number size="small" v-model="scope.row.ProNum" :min="0" :max="scope.row.ActualNum" style="display: flex;align-items: center"></el-input-number>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-row>
				<el-row>
				</el-row>
				<el-row style="display: flex;justify-content: center;margin-bottom: -20px;margin-top: 10px">
					<el-button type="primary" @click="sumbitGoods">确定收货</el-button>
				</el-row>
			</el-dialog>
			<el-dialog title="反馈" v-model="feedbackCheckView">
				<el-form label-width="120px">
					<el-form-item label="类型">
						<el-radio-group v-model="AddForm.ReceiveType">
							<el-radio v-for="item in QueryTypeList" :label="item.Id">{{item.ParmName}}</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="上传签收单">
						<div id="container1">
	
							<div class="ImgPrev" v-for="item in PictureList">
								<div class="post-format-content">
									<div class="post-thumbnail">
										<img :src="item.Url" class="attachment-thumbnail wp-post-image myProPic">
									</div>
									<div class="content-wrap">
										<span class="entry-title">
											<span class="featured-image">
												<i class="el-icon-view" @click="viewPicture(item.Url)"></i>
												<i style="width: 10px;padding: 6px"> </i>
												<i class="el-icon-delete2" @click="delPicture(item.Url)"></i>
											</span>
										</span>
									</div>
								</div>
							</div>
							<el-button icon="plus" style="width: 80px;height: 80px;float: left;" id="btn1" v-show="!fullPicture2"></el-button>
						</div>
	
					</el-form-item>
					<el-form-item label="上传其他图片">
						<div id="container2">
							<div class="ImgPrev" v-for="item in otherPictureList">
								<div class="post-format-content">
									<div class="post-thumbnail">
										<img :src="item.Url" class="attachment-thumbnail wp-post-image myProPic">
									</div>
									<div class="content-wrap">
										<span class="entry-title">
											<span class="featured-image">
												<i class="el-icon-view" @click="viewPicture(item.Url)"></i>
												<i style="width: 10px;padding: 6px"> </i>
												<i class="el-icon-delete2" @click="delPicture(item.Url,'del')"></i>
											</span>
										</span>
									</div>
								</div>
							</div>
							<el-button icon="plus" style="width: 80px;height: 80px;float: left;" id="btn2" v-show="!fullPicture"></el-button>
						</div>
					</el-form-item>
					<el-form-item label="备注">
						<el-input type="textarea" v-model="AddForm.CustomerRemark"></el-input>
					</el-form-item>
				</el-form>
				<el-row style="display: flex;justify-content: center;margin-bottom: -20px">
					<el-button type="primary" @click="feedBackSubmit">确 定</el-button>
				</el-row>
			</el-dialog>
		</div>
	
		<div v-else>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import AgentOrder from './AgentOrder.js';
module.exports = AgentOrder
</script>

<style scoped>
.btm-action {
	display: flex;
	justify-content: center;
	margin: 5px 0px;
}

.formlength {
	width: 160px;
}




/*----------*/

.ImgPrev {
	float: left;
	margin-right: 5px;
	width: 80px;
	height: 80px;
	position: relative;
	margin-bottom: 6px;
}

.post-format-content {
	position: relative;
	background: white;
}

.post-thumbnail {
	max-width: 100%;
	height: auto;
	overflow: hidden;
}

.content-wrap {
	padding: 0;
	position: absolute;
	text-align: center;
	width: 100%;
	top: 0;
	bottom: 0;
	display: table-cell;
	vertical-align: middle;
	overflow: hidden;
	border-radius: 8px;
}

.entry-title {
	display: table;
	font-size: 110%;
	height: 100%;
	width: 100%;
	margin: 0;
}

.edit-link {
	z-index: 2;
}

.featured-image {
	display: table-cell;
	position: relative;
	/*       transition: opacity .25s ease-in-out, background .25s ease-in-out;
                -moz-transition: opacity .25s ease-in-out, background .25s ease-in-out;
                -webkit-transition: opacity .25s ease-in-out, background .25s ease-in-out;*/
	vertical-align: middle;
	z-index: 1;
	color: #fff;
	text-decoration: none;
	opacity: 0;
	padding: 10%;
}

.featured-image:hover {
	border-radius: 8px;
	opacity: 0.9;
	color: #fff;
	background: rgba(0, 0, 0, 0.8);
}

.post-thumbnail img {
	display: block;
}

img {
	max-width: 100%;
	height: auto;
}

.myProPic {
	width: 80px;
	height: 80px;
	border-radius: 8px;
}
</style>


// WEBPACK FOOTER //
// AgentOrder.vue?85aee62c